import React from "react";
import {
  PieChart,
  Pie,
  Cell,
  ResponsiveContainer,
  Tooltip,
} from "recharts";

const AnalyticsDonutChart = ({ title, subtitle, data, centerLabel, emptyMessage }) => {
  const hasData = data?.some((d) => d.value > 0);

  if (!hasData) {
    return (
      <div className="aa-chart-card">
        <div className="aa-chart-card__head">
          <h3>{title}</h3>
          {subtitle ? <p>{subtitle}</p> : null}
        </div>
        <div className="aa-chart-card__empty">{emptyMessage || "No data"}</div>
      </div>
    );
  }

  const total = data.reduce((sum, d) => sum + d.value, 0);

  return (
    <div className="aa-chart-card">
      <div className="aa-chart-card__head">
        <h3>{title}</h3>
        {subtitle ? <p>{subtitle}</p> : null}
      </div>
      <div className="aa-chart-card__body">
        <div className="aa-chart-card__viz">
          <ResponsiveContainer width="100%" height={260}>
            <PieChart>
              <Pie
                data={data}
                cx="50%"
                cy="50%"
                innerRadius={72}
                outerRadius={108}
                paddingAngle={3}
                dataKey="value"
                stroke="none"
              >
                {data.map((entry, index) => (
                  <Cell key={`cell-${index}`} fill={entry.color} />
                ))}
              </Pie>
              <Tooltip
                formatter={(value, name) => [value, name]}
                contentStyle={{
                  borderRadius: 10,
                  border: "1px solid #e7e5e4",
                  boxShadow: "0 8px 24px rgba(0,0,0,0.08)",
                }}
              />
            </PieChart>
          </ResponsiveContainer>
          <div className="aa-chart-card__center">
            <span className="aa-chart-card__center-value">{centerLabel ?? total}</span>
            <span className="aa-chart-card__center-label">Total</span>
          </div>
        </div>
        <ul className="aa-chart-card__legend">
          {data.map((item) => (
            <li key={item.name}>
              <span
                className="aa-chart-card__swatch"
                style={{ background: item.color }}
              />
              <span className="aa-chart-card__legend-name">{item.name}</span>
              <span className="aa-chart-card__legend-val">
                {item.value}
                <em>
                  ({total > 0 ? Math.round((item.value / total) * 100) : 0}%)
                </em>
              </span>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default AnalyticsDonutChart;
